<template>
  <div class="date-field v-centerer" :class="elClasses" @click="editDate">
    <input ref="cal" type="text" style="display:none;position:relative;">
    <div
      class="date-field__icon h-v-centerer"
    >
      <Icon>{{ scheduleMedium }}</Icon>
    </div>

    <div class="date-field__date v-centerer" :placeholder="placeholder">
      {{ displayedDate }}
    </div>
  </div>
</template>

<script>
/**
 * Field to edit a date.
 *
 * @vue-prop {String} value - Date formatted as 'YYYY-MM-DD'
 * @vue-prop {Boolean} [disabled] - Prevent edition.
 */

import $ from 'jquery';
// Components
import Icon from '@/components/icon.vue';
// Utils & assets
import { scheduleMedium } from '@/assets/icons';

export default {

  name: 'DateField',

  components: {
    Icon,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    borderless: Boolean,
    disabled: Boolean,
  },

  data() {
    return {
      scheduleMedium,
    };
  },

  computed: {
    /** Object: Classes applie to $el */
    elClasses() {
      return {
        'generic-border--thin-border generic-border--clickable': !this.borderless,
        'date-field--borderless': this.borderless,
        'date-field--disabled': this.disabled,
      };
    },
    /** String: Formatted date */
    displayedDate() {
      const mDate = this.$moment(this.value);
      return mDate.isValid() ? mDate.format(this.$t('longFullDateFormat')) : '';
    },
  },

  beforeDestroy() {
    $(this.$refs.cal).datepicker('destroy');
  },

  methods: {
    editDate() {
      if (this.disabled) {
        return;
      }
      $(this.$refs.cal).datepicker({
        changeMonth: true,
        changeYear: true,
        showButtonPanel: true,
        showOtherMonths: true,
        selectOtherMonths: true,
        nextText: this.$t('message.NEX'),
        prevText: this.$t('message.PREV'),
        currentText: this.$t('message.TODAY_SHORT'),
        closeText: this.$t('message.DONE'),
        onSelect: (dateText, inst) => {
          this.$emit(
            'input',
            inst.selectedYear
              + (inst.selectedMonth < 9 ? '-0' : '-') + (inst.selectedMonth + 1)
              + (inst.selectedDay < 10 ? '-0' : '-') + inst.selectedDay,
          );
        },
      });
      $(this.$refs.cal).datepicker('show');
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.date-field {
  &.generic-border {
    background: $color-gray-background;
  }

  &.v-centerer {
    height: $main-component-height;
    display: inline-flex;
  }

  &__icon {
    width: 1.1rem;
    height: 100%;
    margin-right: .7rem;

    .icon {
      width: 1.1rem;
      height: 1.1rem;
    }
  }

  &__date {
    height: 100%;
    margin-right: 0.7rem;
    flex: 1;
    min-width: 0px;
  }

  &--borderless {
    &.v-centerer {
      height: auto;
    }
  }

  &--disabled {
    &.generic-border--clickable  {
      cursor: not-allowed;

      &:hover {
        background: white !important;
      }
    }
  }
}

</style>
